import React from 'react';
import SingleChoiceWithTextQuestionEditor, { Props as EditorProps } from './SingleChoiceWithTextQuestionEditor';
import SingleChoiceWithTextQuestionInput, { Props as InputProps } from './SingleChoiceWithTextQuestionInput';

type EditProps = EditorProps & {
  mode: 'edit';
}

type ViewProps = Pick<InputProps, 'question' | 'expand'> & {
  mode: 'view';
}

type SubmitProps = InputProps & {
  mode: 'submit';
  enrollmentId: number;
  sectionId: number;
  caseId?: number;
}

type Props = EditProps | ViewProps | SubmitProps;

const SingleChoiceWithTextQuestion: React.FC<Props> = (props: Props) => {
  const { mode } = props;

  if (mode === 'edit') {
    const {
      surveyId,
      sectionId,
      addQuestion,
      onCancelEdit,
      question,
      updateQuestion,
      disableHideAggregation,
      enableTNA,
    } = props as EditProps;
    return (
      <SingleChoiceWithTextQuestionEditor
        surveyId={surveyId}
        sectionId={sectionId}
        question={question}
        addQuestion={addQuestion}
        updateQuestion={updateQuestion}
        onCancelEdit={onCancelEdit}
        disableHideAggregation={disableHideAggregation}
        enableTNA={enableTNA}
      />
    );
  }

  if (mode === 'view') {
    const {
      question,
      expand,
    } = props as ViewProps;
    return (
      <SingleChoiceWithTextQuestionInput
        question={question}
        expand={expand}
      />
    );
  }

  if (mode === 'submit') {
    const {
      question,
      sectionId,
      caseId,
      enrollmentId,
      defaultSubmission,
      disabled,
      summarizedView,
      onSave,
      getSaveStatus,
      manualSave,
      saveOnBlur,
    } = props as SubmitProps;
    return (
      <SingleChoiceWithTextQuestionInput
        question={question}
        sectionId={sectionId}
        caseId={caseId}
        enrollmentId={enrollmentId}
        disabled={disabled}
        onSave={onSave}
        defaultSubmission={defaultSubmission}
        summarizedView={summarizedView}
        getSaveStatus={getSaveStatus}
        manualSave={manualSave}
        saveOnBlur={saveOnBlur}
      />
    );
  }

  return null;
};

export default SingleChoiceWithTextQuestion;
